import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import SummaryListTableRow from './SummaryListTableRow';

const SummaryListTable = () => {
  const { healthSummaryList } = useSelector((state: RootState) => state.member);
  return (
    <div className='scroll-container'>
      <div className='table-container'>
        <div className='summary-table-body'>
          {healthSummaryList?.map((summary, index) => (
            <SummaryListTableRow key={index} summaryData={summary} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SummaryListTable;
